<template>
  <!-- <div>
    <div class="form-container">
      <el-card class="form-card">
        <el-form ref="t">
          <el-form-item label="Current Image">
            <img class="imagecontainer" :src="this.form.imageurl" />
          </el-form-item>
          <el-form-item label="Image">
            <PictureUpload
            :propertyid="this.propertyid"
              v-on:picture-id="handlePictureid($event)"
              v-on:displaypicturelocally="handlePictureLocally($event)"
              v-on:removePictureId="RemovePictureIdLocally($event)"
            />
          </el-form-item>

          <el-form-item label="Asset Name">
            <el-input
              v-model="form.machinename"
              :rules="inputRules"
              placeholder="ex: Washing Machine"
              required
            ></el-input>
          </el-form-item>

          <el-form-item label="Description">
            <el-input
              v-model="form.description"
              placeholder="ex: a white residential washing machine"
              required
            ></el-input>
          </el-form-item>
          <el-form-item label="qrcodereader">
            <el-button
              v-if="this.form.qrurl == null"
              @click="dialogVisible = true"
            >Associate Qr Code</el-button>
            <el-button
              v-if="this.form.qrurl != null"
              @click="dialogVisible = true"
              class="qrassociated"
            >Qr Code Associated. Click to reassociate</el-button>
            <el-dialog title="Scan Your QR Code" :visible.sync="dialogVisible" width="80%">
              <QrCodeReader
                v-if="this.dialogVisible == true"
                v-on:qrcodescanned="qrcodescanned($event)"
              />
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
              </span>
            </el-dialog>
          </el-form-item>
        </el-form>

        <el-button @click.native="SubmitForm()">Update Asset</el-button>
        <el-button @click="closeForm()">Cancel</el-button>
      </el-card>
    </div>
  </div> -->

  <div>

    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <div v-if="this.loadingFormSubmit == false" class="form-container">
      <el-dialog
        :width="dialogWidth"
        title="Edit Asset"
        :visible.sync="dialogFormVisible"
         @close="closeForm()"  
         :modalAppendToBody="false"    >
      <el-form :model="form" ref="form" :rules="rules">

          <el-form-item label="Current Image">
            <img class="imagecontainer" :src="this.form.imageurl" />
          </el-form-item>
          

          <el-form-item label="Image">
            <PictureUpload
            :propertyid="this.propertyid"
              v-on:picture-id="handlePictureid($event)"
              v-on:displaypicturelocally="handlePictureLocally($event)"
              v-on:removePictureId="RemovePictureIdLocally($event)"
            />
          </el-form-item>

          <el-form-item label="Asset Name"  prop="machinename">
            <el-input
              v-model="form.machinename"
              :rules="inputRules"
              placeholder="ex: Washing Machine"
              required
            ></el-input>
          </el-form-item>

          <el-form-item label="Description">
            <el-input
              v-model="form.description"
              placeholder="ex: a white residential washing machine"
              required
            ></el-input>
          </el-form-item>
          <el-form-item label="qrcodereader">
            <el-button
              @click="dialogVisible = true"
            >
             <span v-if="this.form.qrurl == null">Associate Qr Code </span>
            <span v-else> Change Qr Code </span>
            </el-button>

              <el-dialog title="Scan Your QR Code" :visible.sync="dialogVisible" width="80%" append-to-body>
              <QrCodeReader
                v-if="this.dialogVisible == true"
                v-on:qrcodescanned="qrcodescanned($event)"
              />
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
              </span>
            </el-dialog>
          </el-form-item> 

           <!-- <el-form-item v-if="this.hideFieldsForSubmit == false">
             <p> Custom fields </p>
              <div v-for="(customField, index) in form.customfields" :key="customField.customfieldid">
               
                <div class="custom-field-div"> 
                  <p class="custom-field-header"> Field title </p>
                    <el-select
                      v-model="form.customfields[index].customfieldtitle"
                      filterable
                      default-first-option
                      placeholder="Choose custom field"
                      @change="handleFieldSelection"
                      >
                      <el-option
                          v-for="existingCustomField in allCustomFields"
                          :key="existingCustomField.customfieldid" 
                          :value="existingCustomField.customfieldtitle"                          
                          >                 
                         </el-option>
                    </el-select>            

                </div>

                <div class="custom-field-div">
                  <p class="custom-field-header"> Field value </p>
                  
                  <el-input class="custom-field-input" v-model="form.customfields[index].customfieldvalue" ></el-input>
                </div>

              <p 
              style="display: inline; margin-left: 15px;" 
              @click="removeField(index, customField)"> x 
              </p>

              </div>
              <a class="add-line" @click="addField"> add custom field </a>
           </el-form-item> 
          
          <p class="error" v-if="this.customFieldMissingValue == true"> custom field must have a value</p>
           -->

           
             <el-form-item v-if="this.form.customfields.length > 0">
             <p> Custom fields </p>
              <div v-for="(customField, index) in this.form.customfields" :key="customField.customfieldid">
                   <div class="custom-field-div"> 
                  <p class="custom-field-header"> Field title </p>
                  <p class="custom-field-title" > {{form.customfields[index].customfieldtitle}}</p>
                   </div>
                  <div class="custom-field-div">
                  <p class="custom-field-header"> Field value </p>
                  
                  <el-input class="custom-field-input" v-model="form.customfields[index].customfieldvalue" ></el-input>
                </div>
              </div>
             </el-form-item>


          <el-button class="tst-confirm-edit-issue" @click="SubmitForm()">Update Asset</el-button>
          <el-button class="tst-cancel-button" @click="closeForm()">Cancel</el-button>
        </el-form>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import EventService from "@/services/EventService.js";
import PictureUpload from "@/components/utilities/PictureUploadSingle.vue";
import QrCodeReader from "@/components/utilities/QrCodeReader.vue";
export default {
  components: {
    PictureUpload,
    QrCodeReader
  },
  props: {
    machine: Object,
    property: Object
  },
  data() {
    return {
      allCustomFields: [],
      dialogFormVisible: true,
      dialogWidth: "520px",
      dialog: false,
      dialogVisible: false,
      currentLabels: this.machine.organizationtypesandlabels,
      labelStagingarea: [],
      customFieldMissingValue: false,
      // hideFieldsForSubmit: false,
      propertyid: this.$route.params.propertyid,
      form: {
        machinename: this.machine.machinename,
        machineid: this.machine.machineid,
        model: this.machine.model,
        description: this.machine.description,
        propertyid: this.$route.params.propertyid,
        qrurl: this.machine.qrurl,
        labels: [],
        customfields: this.machine.customfields,
        imageurl: [this.machine.imageurl[0]],
        pictureid: [],
        installdate: this.machine.installdate,
        permissions: this.machine.permissions
      },
      inputRules: [v => (v && v.length != 0) || "This field is required"],
      rules: {
          machinename: [
            { required: true, message: 'Please input Asset name', trigger: 'blur' },
          ],
       },
       invalid: Boolean,
       loadingFormSubmit: false
    };
  },
  mounted(){
      var x = window.matchMedia("(max-width: 979px)");
        if (x.matches) {
        this.dialogWidth = "100%"
         }

      EventService.getPropertyCustomFields( this.$route.params.propertyid).then( response => {
          this.allCustomFields = response.data.customfields;

          // // save original list which shouldn't be changed
          // this.untouchedExistingCustomFields = JSON.parse(JSON.stringify( this.allCustomFields));
          // // remove all those fields which already have a value on this machine

          //  this.form.customfields.forEach( field => {
          //       var matchingFieldInAllArray = this.allCustomFields.filter(i => i.customfieldid == field.customfieldid)[0];

          //       if(matchingFieldInAllArray != undefined)
          //       {
          //          var indexInAllArray = this.allCustomFields.indexOf(matchingFieldInAllArray)
          //          this.allCustomFields.splice(indexInAllArray, 1)
          //       }

          //  });
      });
  },
  methods: {
    handlePictureid($event) {
      //for (const object of $event) {

      this.form.pictureid.push($event.pictureid);

      //}
    },
    handlePictureLocally($event) {
      this.form.imageurl.unshift($event);
    },
    RemovePictureIdLocally(img) {
      this.$delete(this.form.pictureid, this.form.pictureid.indexOf(img));
      this.form.imageurl.shift();
    },
    qrcodescanned($event) {
      this.form.qrurl = $event;
      this.dialogVisible = false;
    },
//  handleFieldSelection(selectedFieldTitle){

//       var formField = this.form.customfields.filter(i => i.customfieldtitle == selectedFieldTitle)[0];
          
//       var indexInFormField = this.form.customfields.indexOf(formField)
        
//       var existingField = this.allCustomFields.filter(i => i.customfieldtitle == selectedFieldTitle)[0];
          
//       var indexInExisitngField = this.allCustomFields.indexOf(existingField)
      
//         this.allCustomFields.splice(indexInExisitngField, 1)

//       if(!formField.customfieldid == null || !formField.customfieldid == "")
//       {
//           this.addBackFieldForSelection(formField.customfieldid);
//       }

//       this.$set(this.form.customfields[indexInFormField], 'customfieldid', existingField.customfieldid);
  
  
//  },
//     addField(){
 
//       var lastInFieldsArray = this.form.customfields[this.form.customfields.length - 1];
      
//       // if there's no field at all let him add
//      if(lastInFieldsArray != undefined){
//              // if the last line isn't filled out or if there's no more existing fields he didnt set, return
//           if(lastInFieldsArray.customfieldvalue == null || lastInFieldsArray.customfieldid == null || this.allCustomFields.length == 0){
//               return;
//             }
//      }

//       this.form.customfields.push({
//             customfieldid: null,
//             customfieldvalue: null,
//             customfieldtitle: null
//           })
//     },
//     removeField(index, currentField){

//        this.form.customfields.splice(index, 1);
//          if(currentField.customfieldid != null)
//        this.addBackFieldForSelection(currentField.customfieldid)
//     },

//     addBackFieldForSelection(fieldId){
//                  var earlierRemovedExistingField = this.untouchedExistingCustomFields
//                                             .filter(i => i.customfieldid == fieldId)[0];

//           this.allCustomFields.push(earlierRemovedExistingField);
//     },
    SubmitForm() {

       this.$refs["form"].validate((valid) => {
          if (valid) {
          } else {
            this.invalid = true;
            return false;
          }
        });
        if(this.invalid == true){
          this.invalid = false;
          return;
        }

      // var missingValueInCustomField = this.form.customfields.some(i => (i.customfieldvalue == null || i.customfieldvalue == "") || (i.customfieldid == null || i.customfieldid == ""));

      // if(missingValueInCustomField == true)
      // {
      //   this.customFieldMissingValue = true;
      //   return;
      // }

    //  this.hideFieldsForSubmit = true;

        // this.allCustomFields.forEach(customField => {

        //     if(this.form.customfields.some( fieldInForm => fieldInForm.customfieldid != customField.customfieldid))
        //     {

        //         this.form.customfields.push({
        //                                   customfieldid: customField.customfieldid,
        //                                   customfieldvalue: null
        //         })
        //     }
        // });

      this.loadingFormSubmit = true;  

      console.log("form is valid and submitted successfully", this.form);
      // this.form.labels = this.form.labels.concat(
      //   this.labelStagingarea,
      //   this.currentLabels
      // );
      EventService.updateAsset(this.machine.machineid, this.form)
        .then(() => {
          this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Asset updated"
          })

          let updateassetpackage = [this.form, this.machine];

          this.$emit("update-asset-locally", updateassetpackage);

          this.closeForm();
        })
        .catch(error => {
           console.log(error);

           this.closeForm();
        });

    },
    // createAssetLabel(assetLabelObject) {
    //   this.labelStagingarea.push(assetLabelObject);
    // },
    // deleteLabel(orgtype) {
    //   this.$delete(this.currentLabels, this.currentLabels.indexOf(orgtype));
    // },
    closeForm() {
      this.$emit("close-EditAssetForm");
    }
  }
};
</script>

<style scoped>
.imagecontainer {
  height: 200px;
  max-height: 200px;
}
.qrassociated {
  background-color: lightgreen;
  color: black;
}
  .custom-field-div{
    display: inline-block;
    margin: 0 45px 0 0;
  }
  .custom-field-input{
    margin: 0px 5px;
  }
  .custom-field-header{
    margin: 0px 0px 0px 10px;
  }
  .custom-field-title{
    margin: 0px 0px 0px 20px;
  }
  .add-line{
      text-decoration: underline;
      color: #02746E;
      cursor: pointer;
  }
  .error{
    color: red;
    font-size: 12px;
    margin: -12px 15px 15px 0px;
   }
</style>
